/* eslint-disable consistent-return */
import { apiPaths, getApiPath, httpStatus } from '../../../constants'
import { Api } from '../../../middlewares'
import { Logger, LoggerTypes } from '../../../utils'

// -- GET
export const GET_PROJECT_PRODUCTS_SUCCESS = 'GET_PROJECT_PRODUCTS_SUCCESS'
export const GET_PROJECT_PRODUCTS_FAILURE = 'GET_PROJECT_PRODUCTS_FAILURE'

// -- CREATE
export const CREATE_PROJECT_PRODUCT_SUCCESS = 'CREATE_PROJECT_PRODUCT_SUCCESS'
export const CREATE_PROJECT_PRODUCT_FAILURE = 'CREATE_PROJECT_PRODUCT_FAILURE'

// -- UPDATE
export const UPDATE_PROJECT_PRODUCT_SUCCESS = 'UPDATE_PROJECT_PRODUCT_SUCCESS'
export const UPDATE_PROJECT_PRODUCT_FAILURE = 'UPDATE_PROJECT_PRODUCT_FAILURE'

// -- DELETE
export const DELETE_PROJECT_PRODUCT_SUCCESS = 'DELETE_PROJECT_PRODUCT_SUCCESS'
export const DELETE_PROJECT_PRODUCT_FAILURE = 'DELETE_PROJECT_PRODUCT_FAILURE'

// -- SEARCH
export const SEARCH_PROJECT_PRODUCTS = 'SEARCH_PROJECT_PRODUCTS'

// -----------------------------------------------------------------------------

/**
 * SEARCH for a project product attribute based on its name.
 *
 * @param {string} terms Text to be searched within the project's parameter.
 * @returns {Promise<array<object>>}
 */
export const searchProjectProducts = (terms) => async (dispatch) => {
  dispatch({
    type: SEARCH_PROJECT_PRODUCTS,
    data: terms
  })
}

/**
 * GET the list of products attributes that belong to this project.
 *
 * @param {uuid} pid Project ID
 * @returns {Array<object>}
 */
export const getProjectProducts = (pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_PRODUCT_LIST, { pid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] productsActions.getProducts()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_PROJECT_PRODUCTS_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_PROJECT_PRODUCTS_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific product attribute that belong to a project.
 *
 * @param {object} newProduct New product to create.
 * @param {uuid} pid Project ID.
 * @returns {Array<object>}
 */
export const createProjectProduct = (newProduct, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_PRODUCT_CREATE, { pid })
  const api = new Api(path)
  const result = await api.create(newProduct)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] productsActions.createProjectProduct()', { path, pid, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_PROJECT_PRODUCT_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_PROJECT_PRODUCT_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific project product attribute.
 *
 * @param {object} newProduct Product object to update.
 * @param {uuid} did Project Product ID.
 * @param {uuid} pid Project ID.
 * @returns {Array<object>}
 */
export const updateProjectProduct = (newProduct, did, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_PRODUCT_UPDATE, { pid, did })
  const api = new Api(path)
  const result = await api.update(newProduct)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] productsActions.updateProjectProduct()', {
    path,
    newProduct,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_PROJECT_PRODUCT_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_PROJECT_PRODUCT_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific project product attribute.
 *
 * @param {uuid} did Project Product ID.
 * @param {uuid} pid Project ID.
 * @returns {Array<object>}
 */
export const deleteProjectProduct = (did, pid) => async (dispatch) => {
  const path = getApiPath(apiPaths.PROJECT_PRODUCT_DELETE, { pid, did })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] productsActions.deleteProjectProduct()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_PROJECT_PRODUCT_SUCCESS,
      data: did
    })
  }

  return dispatch({
    type: DELETE_PROJECT_PRODUCT_FAILURE,
    data: result.data
  })
}
